import { deleteCurrentDoc } from "./dataActions";
import { OPEN_MODAL, CLOSE_MODAL } from "./types";

export const open = (name, params) => {
  return {
    type: OPEN_MODAL,
    payload: name,
  };
};

export const close = () => async (dispatch) => {
  dispatch(deleteCurrentDoc());
  dispatch({
    type: CLOSE_MODAL,
  });
};
